var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_9403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 2.30078L17.6992 2.77344C18.0664 3.14063 18.0664 3.73438 17.6992 4.09766L16.5625 5.23828L14.7617 3.4375L15.8984 2.30078C16.2656 1.93359 16.8594 1.93359 17.2227 2.30078H17.2266ZM8.19531 10.0078L13.4375 4.76172L15.2383 6.5625L9.99219 11.8047C9.87891 11.918 9.73828 12 9.58594 12.043L7.30078 12.6953L7.95313 10.4102C7.99609 10.2578 8.07813 10.1172 8.19141 10.0039L8.19531 10.0078ZM14.5742 0.976563L6.86719 8.67969C6.52734 9.01953 6.28125 9.4375 6.15234 9.89453L5.03516 13.8008C4.94141 14.1289 5.03125 14.4805 5.27344 14.7227C5.51563 14.9648 5.86719 15.0547 6.19531 14.9609L10.1016 13.8438C10.5625 13.7109 10.9805 13.4648 11.3164 13.1289L19.0234 5.42578C20.1211 4.32812 20.1211 2.54688 19.0234 1.44922L18.5508 0.976563C17.4531 -0.121094 15.6719 -0.121094 14.5742 0.976563ZM3.4375 2.5C1.53906 2.5 0 4.03906 0 5.9375V16.5625C0 18.4609 1.53906 20 3.4375 20H14.0625C15.9609 20 17.5 18.4609 17.5 16.5625V12.1875C17.5 11.668 17.082 11.25 16.5625 11.25C16.043 11.25 15.625 11.668 15.625 12.1875V16.5625C15.625 17.4258 14.9258 18.125 14.0625 18.125H3.4375C2.57422 18.125 1.875 17.4258 1.875 16.5625V5.9375C1.875 5.07422 2.57422 4.375 3.4375 4.375H7.8125C8.33203 4.375 8.75 3.95703 8.75 3.4375C8.75 2.91797 8.33203 2.5 7.8125 2.5H3.4375Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_9403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.3633f38d073484077cc80ddd580ffc89.svg";
export { ForwardRef as ReactComponent };